export default __webpack_public_path__ + "static/media/incoming-info.4ae8c312.svg";